// Single source of truth for the basemap the event maps draw on.
//
// CARTO's raster basemaps were keyless when these maps were built, and the
// components said so. That changed: unauthenticated tile requests now come back
// dimmed with "API KEY REQUIRED" stamped diagonally across every tile, which is
// what the Discover and venue maps were showing.
//
// A key is free — no CARTO account, 5 million tile requests a month, which is
// far beyond anything this app will draw. Request one at
// https://carto.com/basemaps/apikey and set REACT_APP_CARTO_KEY in Vercel.
//
// Without the key the URL is unchanged from before, so the maps keep working
// exactly as they do today, watermark and all, rather than breaking outright.
const CARTO_KEY = process.env.REACT_APP_CARTO_KEY || '';

export const CARTO_DARK_TILES =
  `https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png${CARTO_KEY ? `?key=${CARTO_KEY}` : ''}`;

export const CARTO_ATTRIBUTION = '&copy; OpenStreetMap contributors &copy; CARTO';
